module.exports = __webpack_public_path__ + "images/113_160.jpg";